module.exports = __webpack_public_path__ + "img/profiles.3308c5dd.png";